import { render, staticRenderFns } from "./SurveyDetail.vue?vue&type=template&id=5a409d2d&scoped=true&"
import script from "./SurveyDetail.vue?vue&type=script&lang=js&"
export * from "./SurveyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a409d2d",
  null
  
)

export default component.exports